export default "__VITE_ASSET__BCraf04Z__"